// Error messages people see. The API client maps every failure to one of these (or to the backend's own
// Indonesian text); raw framework errors are never shown.

export const ERRORS = {
  offline: 'Tidak dapat terhubung ke sistem. Periksa koneksi internet, lalu coba lagi.',
  server: 'Sistem sedang mengalami gangguan. Coba lagi beberapa saat lagi.',
  unprocessable: 'Permintaan tidak dapat diproses.',
  unexpected: 'Terjadi kesalahan yang tidak terduga. Muat ulang halaman lalu coba lagi.',
  loadFailed: 'Data tidak dapat dimuat.',
  aborted: 'Dibatalkan.',
  /** prefix for an error shown over data that is still on screen */
  stale: 'Data mungkin belum terbaru: ',
} as const;

/** Fallback text per HTTP status when the backend sent nothing readable. */
export const STATUS_ERRORS: Record<number, string> = {
  400: 'Data yang dikirim tidak valid.',
  401: 'Sesi Anda berakhir. Silakan masuk lagi.',
  403: 'Anda tidak punya akses untuk tindakan ini.',
  404: 'Data tidak ditemukan.',
  409: 'Tindakan ini bertabrakan dengan perubahan lain. Muat ulang lalu coba lagi.',
  413: 'Data terlalu besar.',
  429: 'Terlalu banyak percobaan. Tunggu sebentar lalu coba lagi.',
};

/**
 * Binding a tag to a cylinder refused (Registrasi, Ganti tag), by the backend's code. TAG_ALREADY_USED and
 * TAG_READ_ELSEWHERE show the server's own sentence when it sent one (it names the cylinder or the place); these are
 * the fallback.
 */
export const TAG_ERRORS: Record<string, string> = {
  TAG_ALREADY_USED: 'Tag ini sudah pernah dipakai tabung lain. Satu tag hanya dapat dipakai satu kali; gunakan tag baru.',
  TAG_TID_MISSING: 'ID chip (TID) belum terbaca. Dekatkan tag lebih lama ke Reader, lalu coba lagi.',
  TAG_READ_STALE: 'Tag tidak lagi terbaca oleh Reader yang aktif. Dekatkan kembali tag ke Reader, lalu coba lagi.',
  TAG_READ_ELSEWHERE: 'Tag baru belum terbaca oleh Reader di Titik Distribusi tempat tabung tercatat.',
  TAG_TID_MISMATCH: 'ID chip (TID) tag ini berbeda dengan yang terbaca Reader. Dekatkan ulang tag ke Reader, lalu coba lagi.',
};
